var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E3E9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 16.5953C16.3318 16.5953 16.6004 16.3267 16.6004 15.9953C16.6004 15.6639 16.3318 15.3953 16.0004 15.3953C15.669 15.3953 15.4004 15.6639 15.4004 15.9953C15.4004 16.3267 15.669 16.5953 16.0004 16.5953Z",
    stroke: "#1638B1",
    strokeWidth: 1.54286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 12.3953C16.3318 12.3953 16.6004 12.1267 16.6004 11.7953C16.6004 11.4639 16.3318 11.1953 16.0004 11.1953C15.669 11.1953 15.4004 11.4639 15.4004 11.7953C15.4004 12.1267 15.669 12.3953 16.0004 12.3953Z",
    stroke: "#1638B1",
    strokeWidth: 1.54286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 20.7953C16.3318 20.7953 16.6004 20.5267 16.6004 20.1953C16.6004 19.8639 16.3318 19.5953 16.0004 19.5953C15.669 19.5953 15.4004 19.8639 15.4004 20.1953C15.4004 20.5267 15.669 20.7953 16.0004 20.7953Z",
    stroke: "#1638B1",
    strokeWidth: 1.54286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.72c0e53cc9a7c996896e7350358c3168.svg";
export { ForwardRef as ReactComponent };